import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchNotificationService } from '../search-notification.service';

@Component({
  selector: 'app-user-view-vacant-vehicle-search',
  templateUrl: './user-view-vacant-vehicle-search.component.html',
  styleUrls: ['./user-view-vacant-vehicle-search.component.sass']
})
export class UserViewVacantVehicleSearchComponent implements OnInit {

  searchDetails: any = null;
  loading = false;

  constructor(
    private searchHistoryService: SearchNotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getSearchDetails();
  }

  getSearchDetails(): void {

    this.route.queryParams.subscribe((params) => {

      const id = params['id'];

      if (!id) {
        console.error('Search history ID not found');
        return;
      }

      this.loading = true;

      this.searchHistoryService
        .getUserSearchHistoryById(id)
        .subscribe(
          (res: any) => {

            this.loading = false;

            if (res && res.success) {
              this.searchDetails = res.data;
            } else {
              this.searchDetails = null;
            }

          },
          (error) => {

            this.loading = false;
            this.searchDetails = null;

            console.error(
              'Error fetching user search history details:',
              error
            );

          }
        );
    });
  }

  backToList(): void {
    this.router.navigate([
      '/dashboard/user-vacant-vehicle-search'
    ]);
  }
}